import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { api } from './api';
import userSlice from './userSlice';
import constantsSlice from './constantsSlice';
import interviewSlice from './interviewSlice';
import messagesSlice from './messagesSlice';
import optionSlice from './optionSlice';
import matchRuleSlice from './matchRuleSlice';

const rootReducer = combineReducers({
  user: userSlice,
  messages: messagesSlice,
  constants: constantsSlice,
  interview: interviewSlice,
  option: optionSlice,
  matchRule: matchRuleSlice,
  [api.reducerPath]: api.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
